export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '1a4bb788-af3e-4aee-9133-c362db29b1f4';
export const MODAL_CLOSE_SEC = 2.5;
